// extracted by mini-css-extract-plugin
module.exports = {"scrollFadeContainer":"useFilterBarScroll_scrollFadeContainer__0MXku"};